import $ from 'jquery'
import { registerComponent } from '../app'
import { SELECT_SS_CATEGORY, DESELECT_SS_CATEGORY } from '../events'

const ProductList = (scope, el) => {
	const $items = $(el).find('[data-product]')

	const state = {
		selected: []
	}

	function updateVisibility() {
		$items.removeAttr('style')

		if (!state.selected.length) {
			return
		}

		$items.each(function() {
			if (state.selected.indexOf(this.getAttribute('data-simple-seven')) == -1) {
				this.style.display = 'none'
			}
		})
	}

	function updateUrl() {
		let url = new URL(window.location.href)
		let queryString = url.search
		let searchParams = new URLSearchParams(queryString)

		searchParams.delete('categories')

		if (state.selected.length && searchParams.has('categories')) {
			searchParams.append('categories', state.selected.join(','))
		} else if (state.selected.length) {
			searchParams.set('categories', state.selected.join(','))
		}

		// change the search property of the main url
		url.search = searchParams.toString()

		// the new url string
		let newUrl = url.toString()

		if (history.pushState) {
			window.history.pushState({ path: newUrl }, '', newUrl)
		}
	}

	function getUrl() {
		let url = new URL(window.location.href)
		let queryString = url.search
		let searchParams = new URLSearchParams(queryString)

		let categories = searchParams.get('categories')

		if (categories && categories.length) {
			categories = categories.split(',')

			categories.map(category => {
				scope.emit(SELECT_SS_CATEGORY, category)
			})
		}
	}

	scope.on(DESELECT_SS_CATEGORY, category => {
		if (!category) {
			state.selected = []
			$items.removeAttr('style')
		} else {
			state.selected.splice(state.selected.indexOf(category), 1)
		}
		updateVisibility()
		updateUrl()
	})

	scope.on(SELECT_SS_CATEGORY, category => {
		if (state.selected.indexOf(category) == -1) {
			state.selected.push(category)
		}
		updateVisibility()
		updateUrl()
	})

	scope.start(() => {
		getUrl()
	})
}

registerComponent('product-list', ProductList)
